import { IRootState } from '../../../store'

export const getClientDataImportErrorSelector = (state: IRootState): string | null =>
  state.clientData.clientDataImportError
